<template>
  <div
    class="option-list__container"
    :class="['type--' + type, ( 'column--' + getNumberOfColumns(type).toString() )]"
  >
    <div
      v-if="options.length"
      class="option-list"
      :class="'type--' + type"
    >
      <buy-guide-option v-for="(option, optionIndex) in options"
        :key="option.Header"
        :optionIndex="optionIndex"
        :stepIndex="currentStepIndex"
        :option="option"
      >
      </buy-guide-option>
    </div>
    <div class="measure-container" v-if="currentStep.Choice">
      <dimensions
        :size-options="JSON.stringify(option.Dimensions)"
        v-for="(option) in filteredOptions"
        v-bind:key="option.Header"
      >
        <template v-slot:custom-input-droplet-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="22" viewBox="0 0 100 22">
            <path fill="#005896" d="M0 2V0h100v2C63.8 2 59.8 22 50 22 40.2 22 36.2 2 0 2z"/>
          </svg>
        </template>
        <template v-slot:measure-droplet-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="22" viewBox="0 0 100 22">
            <path fill="#005896" d="M0 2V0h100v2C63.8 2 59.8 22 50 22 40.2 22 36.2 2 0 2z"/>
          </svg>
        </template>
        <template v-slot:measure-installation-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="284" height="227" viewBox="0 0 284 227">
            <path fill="#3C3C3C" fill-rule="evenodd" d="M178.288 114v-1.056h1.008l3.152-8.432h-1.2v-1.04h4.8v1.04h-1.2l3.152 8.432h1.008V114h-3.52v-1.04h1.232l-.944-2.592h-4.304l-.944 2.592h1.28V114h-3.52zm3.536-4.64h3.6l-1.792-4.912-1.808 4.912zM210.752 23v-1.056h1.344v-8.416h-1.344v-1.056h3.952c3.664 0 6.048 2.032 6.048 5.152 0 3.184-2.224 5.376-6.096 5.376h-3.904zm2.544-1.056h1.504c3.152 0 4.736-1.76 4.736-4.336 0-2.528-1.888-4.08-4.864-4.08h-1.376v8.416zM149.752 182v-1.056h1.344v-8.416h-1.344v-1.056h4.224c2.496 0 3.536 1.264 3.536 2.672 0 1.264-.784 2.112-1.92 2.464 1.408.368 2.224 1.152 2.224 2.512 0 1.664-1.328 2.88-3.648 2.88h-4.416zm2.528-1.04h1.92c1.552 0 2.432-.784 2.432-1.904 0-1.264-1.04-1.936-2.768-1.936h-1.584v3.84zm0-4.816h1.552c1.664 0 2.496-.768 2.496-1.888 0-1.088-.832-1.744-2.384-1.744h-1.664v3.632zm86.008-.952c-3.248 0-5.392-2.512-5.392-5.408 0-3.248 2.496-5.504 5.344-5.504 2.208 0 3.936 1.328 3.936 2.592 0 .592-.4 1.04-.928 1.04-.496 0-.88-.368-.88-.848 0-.304.192-.56.4-.64-.288-.464-1.2-1.056-2.544-1.056-2.4 0-4.112 2.032-4.112 4.4 0 2.256 1.696 4.336 4.176 4.336 1.264 0 2.32-.48 3.264-1.36l.704.848c-1.056 1.056-2.512 1.6-3.968 1.6zm-192 0c-3.248 0-5.392-2.512-5.392-5.408 0-3.248 2.496-5.504 5.344-5.504 2.208 0 3.936 1.328 3.936 2.592 0 .592-.4 1.04-.928 1.04-.496 0-.88-.368-.88-.848 0-.304.192-.56.4-.64-.288-.464-1.2-1.056-2.544-1.056-2.4 0-4.112 2.032-4.112 4.4 0 2.256 1.696 4.336 4.176 4.336 1.264 0 2.32-.48 3.264-1.36l.704.848c-1.056 1.056-2.512 1.6-3.968 1.6zM64 153.5V52h107.5l-3.75-3.75.7-.7L172 51.1V30.9l-3.55 3.55-.7-.7L171.5 30H29v123.5l3.75-3.75.7.7L29.9 154h33.2l-3.55-3.55.7-.7L64 153.5zm0 2l-3.75 3.75-.7-.7L63.1 155H29.9l3.55 3.55-.7.7L29 155.5V198h35v-42.5zM208.976 1H1.678l27.034 28h166.44l-1.992-6.133.942-.306 1.551 4.775L208.456 2.21 203.68 3.76l-.306-.941 5.6-1.82zm.871 0l1.993 6.133-.942.306-1.551-4.775-12.803 25.126 4.775-1.551.306.941-5.6 1.82h59.263l27.034-28h-72.475zM173.5 52H220v101.854l3.854-3.854.707.707-3.293 3.293h32.025L250 150.707l.707-.707 4 4H255v.293V30h-81.5l3.75 3.75-.7.7L173 30.9v20.2l3.55-3.55.7.7L173.5 52zm-33 146h77.67l-7.17-6.273V96h-71v101.1l3.55-3.55.7.7-3.75 3.75zm-2 0l-3.75-3.75.7-.7 3.55 3.55V96H73v95.727L65.83 198h72.67zM140 61v34h71V61h-71zm-1 0H73v34h66V61zm-.5-8H65.707l7 7H139v-6.1l-3.55 3.55-.7-.7L138.5 53zm2 0l3.75 3.75-.7.7L140 53.9V60h71.293l7-7H140.5zM220 155.854V198h35v-42.586l-4.293 4.293L250 159l4-4h-33.44l4 4-.706.707-3.854-3.853zM65 96.504v100.894l7-6.125V96h-6.09l3.65 3.65-.706.707L65 96.504zm0-2l3.854-3.854.707.707L65.918 95H72V60.707l-7-7v40.797zm154 1.56l-4.293 4.293-.707-.707 3.65-3.65H212v95.273l7 6.125V96.064zm0-1.121V53.707l-7 7V95h5.643L214 91.357l.707-.707L219 94.943zM1 1.738v223.555l27-27V29.702L1 1.738zm282 0l-27 27.964v168.59l27 27V1.739zM1.707 226h280.586l-27-27H28.707l-27 27zM0 0h284v227H0V0zm224.016 203l.857 1h-1.317l-.857-1h1.317zm3.428 4l.857 1h-1.317l-.857-1h1.317zm3.429 4l.857 1h-1.317l-.857-1h1.317zm3.428 4l.858 1h-1.318l-.857-1h1.317zm3.429 4l.857 1h-1.317l-.857-1h1.317zm3.429 4l.857 1h-1.317l-.858-1h1.318zM61.3 203l-.857 1h-1.317l.857-1h1.317zm-3.428 4l-.857 1h-1.317l.857-1h1.317zm-3.429 4l-.857 1H52.27l.857-1h1.317zm-3.428 4l-.857 1H48.84l.858-1h1.317zm-3.429 4l-.857 1h-1.317l.857-1h1.317zm-3.428 4l-.858 1h-1.317l.857-1h1.318z"/>
          </svg>
        </template>
      </dimensions>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState, mapGetters, mapMutations } from 'vuex';
import Option from '@/components/buy-guide/components/option/option.vue';
import Dimensions from '@/components/product-presentation/product-filters/dimensions/dimensions.vue';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
        currentStepIndex: state => state.buyGuide.currentStepIndex,
        steps: state => state.buyGuide.steps,
        status: state => state.buyGuide.status,
        results: state => state.buyGuide.results
      }),
      ...mapGetters('buyGuide', {
        getCurrentStep: 'getCurrentStep'
      }),
      currentStep () {
        return this.getCurrentStep(this.currentStepIndex)
      },
      filteredOptions: function () {
        return this.options.filter(x => x.Selected === true);
      }
    },
    components: {
      'buy-guide-option': Option,
      'dimensions': Dimensions
    },
    methods: {
      ...mapMutations(['buyGuide/setDimensions'])
    }
})
export default class GarageType extends Vue {
  @Prop() type;
  @Prop() options;
  @Prop() getNumberOfColumns;

  created() {
    // console.log('GarageType created');
    bus.$on('updateProductDimensions', dimensions => {
      // console.log('garageType updateProductDimensions', this.filteredOptions[0].Header, dimensions)
      this.filteredOptions.length && this.setDimensions(this.filteredOptions[0], dimensions);

    })
  }

  setDimensions(option, dimensions) {
    this.$store.commit(
      'buyGuide/setDimensions', {
        option,
        dimensions
      }
    )
  }

  mounted() {
  }

}

</script>

<style>

</style>
